export enum VehicleCheckpointFieldType {
  textType = 'TEXT',
  fileType = 'FILE',
  numberType = 'NUMBER',
  selectType = 'SELECT',
}
